import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { getCountdown } from "../helper/Countdown";
import { convertCurrency } from "../helper/CurrencyConverter";

const SampleNextArrow = memo(({ className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
  >
    <i className="ph ph-caret-right" />
  </button>
));

const SamplePrevArrow = memo(({ className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
  >
    <i className="ph ph-caret-left" />
  </button>
));

const HotDealsOne = ({ selectedCurrency }) => {
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  const [todayProducts, setTodayProducts] = useState([]);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/offers/hotDeals`);
        if (res.data && Array.isArray(res.data)) {
          const activeOffers = res.data.filter((b) => b.status);
          const assigned = [activeOffers[0]].filter(Boolean);
          setOffers(assigned);
        }
      } catch (err) {
        console.error("Error fetching Hot Deals section offer:", err);
      }
    };
    fetchOffer();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (offers.length > 0) {
        const updated = offers.map((offer) => getCountdown(offer.expiryDate));
        setTimeLeft(updated);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [offers]);

  // useEffect(() => {
  //   const fetchTodayDeals = async () => {
  //     try {
  //       const res = await axios.get(`${process.env.REACT_APP_API_URL}/product/all`);
  //       if (res.data && res.data.success) {
  //         const today = new Date().toISOString().split("T")[0];
  //         const todayDeals = res.data.data.filter((p) => {
  //           const created = p.createdAt?.split("T")[0];
  //           const updated = p.updatedAt?.split("T")[0];
  //           return created === today || updated === today;
  //         });
  //         setTodayProducts(todayDeals);
  //       }
  //     } catch (err) {
  //       console.error("HotDealsOne fetch error:", err);
  //     }
  //   };
  //   fetchTodayDeals();
  // }, []);

  useEffect(() => {
  const fetchTodayDeals = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/product/all`);

      if (res.data && res.data.success) {
        const all = res.data.data;
        const activeProducts = all.filter(p => p.status === "Active");
        const today = new Date().toISOString().split("T")[0];

        const todayDeals = activeProducts.filter((p) => {
          const created = p.createdAt?.split("T")[0];
          const updated = p.updatedAt?.split("T")[0];
          return created === today || updated === today;
        });

        setTodayProducts(todayDeals);
      }
    } catch (err) {
      console.error("HotDealsOne fetch error:", err);
    }
  };

  fetchTodayDeals();
}, []);


  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1599, settings: { slidesToShow: 4 } },
      { breakpoint: 1399, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3, arrows: false, dots: false } },
      { breakpoint: 768, settings: { slidesToShow: 2, arrows: false, dots: false } },
      { breakpoint: 575, settings: { slidesToShow: 2, arrows: false, dots: false } },
      { breakpoint: 480, settings: { slidesToShow: 1, arrows: false, dots: false } },
    ],
  };

  return (
    <section className="hot-deals pt-80">
      <div className="container container-lg">
        <div className="section-heading flex-between flex-wrap gap-8">
          <h5 className="mb-0">Hot Deals Today</h5>
          <div className="flex-align mr-point gap-16">
            <Link
              to="/shop"
              className="text-sm fw-medium text-gray-900 hover-text-main-600 hover-text-decoration-underline"
            >
              View All Deals
            </Link>
          </div>
        </div>

        <div className="row g-12 hot-deals-wrapper">
          {offers.map((offer, index) => (
            <div className="col-xxl-4 col-md-12 offer-card-col" key={index}>
              <div className="hot-deal-offer position-relative rounded-16 bg-main-600 overflow-hidden p-10 z-1 text-center">
                <img
                  src="assets/images/shape/offer-shape.png"
                  alt=""
                  className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                />
                <Link to={offer.link || "/shop"} className="hot-deals__thumb">
                  <img src={offer.image} alt="Offer Img" />
                </Link>
                <div className="py-xl-4">
                  <h4 className="text-white mb-8">{offer.title}</h4>
                  <span className="text-sm text-gray-900">{offer.subTitle}</span>
                  <div className="countdown my-2" id="countdown4">
                    {offers.map((offer, index) => {
                      const countdown = getCountdown(offer.expiryDate);
                      return (
                        <div className="row-xxl-4" key={index}>
                          <ul className="countdown-list flex-center flex-wrap">
                            <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                              <span className="days" />{countdown.days} Days
                            </li>
                            <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                              <span className="hours" />{countdown.hours} Hours
                            </li>
                            <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                              <span className="minutes" />{countdown.minutes} Min
                            </li>
                            <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                              <span className="seconds" />{countdown.seconds} Sec
                            </li>
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="col-xxl-8 col-md-12 product-slider-col">
            {todayProducts.length === 0 ? (
              <div className="text-center p-32 text-gray-500">
                <h6 className="text-lg fw-semibold">You are late, better luck next time!</h6>
              </div>
            ) : (
              <div className="hot-deals-slider arrow-style-two">
                <Slider {...settings}>
                  {todayProducts.map((item) => (
                    <div key={item._id}>
                      <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                        <Link
                          to={`/product-details/${item._id}`}
                          className="product-card__thumb flex-center"
                        >
                          <img
                            src={item.images[0] || "assets/images/thumbs/product-img1.png"}
                            alt={item.name}
                          />
                        </Link>

                        <div className="product-card__content mt-12">
                          <h6 className="title text-lg fw-semibold mt-12 mb-8">
                            <Link
                              to={`/product-details/${item._id}`}
                              className="link product-name"
                              title={item.name}
                            >
                              {item.name}
                            </Link>
                          </h6>

                          <div className="product-card__price mb-16">
                            {item.oldPrice && (
                              <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                {selectedCurrency}{" "}
                                {convertCurrency(item.oldPrice, selectedCurrency).toFixed(2)}
                              </span>
                            )}
                            <span className="text-heading text-md fw-semibold">
                              {selectedCurrency}{" "}
                              {convertCurrency(item.price, selectedCurrency).toFixed(2)}{" "}
                              <span className="text-gray-500 fw-normal">/Qty</span>
                            </span>
                          </div>

                          {/* Rating */} 
                          <div className="product-card__rating flex-align mb-6 gap-6">
                            {(() => {
                              const reviews = item.reviews || [];
                              const total = reviews.length;

                              const avg =
                                total > 0 ? (reviews.reduce((sum, r) => sum + (r.ratings || 0), 0) / total).toFixed(1) : "0.0";

                              return (
                                <>
                                  <span className="text-xs fw-bold text-gray-600">{avg}</span>
                                  <span className="text-15 fw-bold text-warning-600 d-flex"><i className="ph-fill ph-star" /></span>
                                  <span className="text-xs fw-bold text-gray-600">({total})</span>
                                </>
                              );
                            })()}
                          </div>

                          {/* <div className="flex-align gap-4">
                            <span className="text-main-600 text-md d-flex">
                              <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                              {item.store || "By MordenBazaar Store"}
                            </span>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 991px) {

          /* ALWAYS keep title + view-all on same line in mobile/tab */
          .section-heading {
            width: 100%;
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            flex-wrap: nowrap !important;
          }

          .hot-deals .mr-point {
            margin: 0 !important;
            display: flex !important;
            justify-content: flex-end !important;
            align-items: center !important;
          }

          .hot-deals-wrapper {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .offer-card-col,
          .product-slider-col {
            width: 100% !important;
            max-width: 100% !important;
            flex: 1 1 100% !important;
          }

          .hot-deal-offer img {
            width: 100% !important;
            height: auto !important;
            object-fit: cover !important;
          }

          .hot-deals-slider {
            width: 100% !important;
          }

          .slick-slide > div {
            margin: 0 auto !important;
          }

          .product-card {
            width: 100% !important;
            max-width: 100% !important;
          }
        }

        @media (max-width: 575px) {
          .hot-deals-wrapper {
            gap: 12px !important;
          }

          .product-card__thumb img {
            height: 110px !important;
            object-fit: cover !important;
            border-radius: 8px;
          }
        }
      `}</style>

    </section>
  );
};

export default HotDealsOne;
